<h1 mat-dialog-title class="text-center">Automatic Serial Creation</h1>
<div mat-dialog-content class="contentt">
    <div class="card s-card1">
        <div class="card-body">
            <div class="row">
                <div class="col-md-2">
                    <label for="" class="label1">Item Code</label>
                    <label for="" class="label2">CC235325</label>
                </div>
                <div class="col">
                    <label for="" class="label1">Item Description</label>
                    <label for="" class="label2">Coca Cola 1.25 l Soft Drink</label>
                </div>
                <div class="col">
                    <label for="" class="label1">Warehouse Code</label>
                    <label for="" class="label2">DL09210312</label>
                </div>
                <div class="col">
                    <label for="" class="label1">Total Qty Needed</label>
                    <label for="" class="label2">500</label>
                </div>
            </div>
        </div>
    </div>
  <div class="entry-forms mt-4">
    <div class="row">
        <div class="col-md-4 pe-4 border-end">
            <div class="">
                <label class="f-label">Quantity</label>
                <mat-form-field class="full-width" appearance="outline">
                    <input type="text" matInput>
                </mat-form-field>
            </div>
            <div class="">
                <label class="f-label">Mfr Serial No.</label>
                <mat-form-field class="full-width" appearance="outline">
                    <input type="text" matInput>
                    <img src="../../../../assets/images/batch.svg" (click)="openDialog1()" alt="" matSuffix class="me-2">
                </mat-form-field>
            </div>
            <div class="">
                <label class="f-label">Serial No.</label>
                <mat-form-field class="full-width" appearance="outline">
                    <input type="text" matInput>
                    <img src="../../../../assets/images/batch.svg" (click)="openDialog1()" alt="" matSuffix class="me-2">
                </mat-form-field>
            </div>
            <div class="">
                <label class="f-label">Lot No.</label>
                <mat-form-field class="full-width" appearance="outline">
                    <input type="text" matInput>
                    <img src="../../../../assets/images/batch.svg" (click)="openDialog1()" alt="" matSuffix class="me-2">
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-4 pe-4 ps-4">
            <div class="">
                <label class="f-label">Admission Date</label>
                <mat-form-field class="full-width" appearance="outline">
                    <input matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="">
                <label class="f-label">Manufacturing Date</label>
                <mat-form-field class="full-width" appearance="outline">
                    <input matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="">
                <label class="f-label">Expiration Date</label>
                <mat-form-field class="full-width" appearance="outline">
                    <input matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-4 ps-4 border-start">
            <div class="">
                <label class="f-label">Mfr Warranty Start</label>
                <mat-form-field class="full-width" appearance="outline">
                    <input matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="">
                <label class="f-label">Mfr Warranty End</label>
                <mat-form-field class="full-width" appearance="outline">
                    <input matInput [matDatepicker]="picker1">
                    <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
    <div class="row w-100">
        <div class="col-md-12 text-end">
            <button mat-raised-button color="primary" mat-dialog-close>Create</button>
        </div>
    </div>
</div>